import axios from "axios";
import { useAuth } from "oidc-react";
import { useEffect } from "react";
import { API_PATH, TOKEN_KEY } from "../constants";


const axiosInstance = axios.create({
  baseURL: API_PATH
});

const useAxios = () => {
  const auth = useAuth();

  useEffect(() => {
    if (!axiosInstance.defaults.headers.common[TOKEN_KEY] &&
        !auth.isLoading && auth.userData?.access_token) {
      axiosInstance.defaults.headers.common[TOKEN_KEY] = auth.userData.access_token;
    }
  }, [auth.isLoading, auth.userData, auth.userData?.access_token])

  return axiosInstance;
};

export default useAxios;